import * as React from 'react';
import { TreeSelect } from 'antd';
import { TreeSelectProps } from 'antd/lib';
export interface IBaseSelectProps extends TreeSelectProps {}

export default function BaseTreeSelect(props: IBaseSelectProps) {
  const { className = '', ...rest } = props;
  const ref = React.useRef<any>(null);

  React.useEffect(() => {
    if (
      ref?.current?.querySelector('input')?.disabled &&
      ref.current.querySelector('.ant-select-selection-placeholder')
    ) {
      ref.current.querySelector('.ant-select-selection-placeholder').innerText = 'Chưa có dữ liệu';
    }
  }, []);

  return (
    <span ref={ref} className="bg-red-400">
      <TreeSelect className={'base-tree-select w-full ' + className} {...rest} />
    </span>
  );
}
